import React from 'react';

export default function AboutSection() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="py-20 md:py-32 bg-white"
      aria-label="What is B2B Content Syndication"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto text-center mb-12">
          <span className="inline-block text-sm font-semibold tracking-wide uppercase text-[#4AC5DB] mb-4">
            What We Do
          </span>
          <h2
            data-testid="about-heading"
            className="font-['Outfit'] text-3xl md:text-5xl font-semibold text-slate-900 tracking-tight"
          >
            What is B2B Content Syndication?
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          <div className="space-y-6">
            <p className="text-base md:text-lg leading-relaxed text-slate-600">
              <strong className="text-slate-800">B2B content syndication</strong> is the strategic
              process of redistributing your valuable web-based content &mdash; including blogs,
              whitepapers, case studies, infographics, and videos &mdash; across third-party platforms
              to expand your audience reach.
            </p>
            <p className="text-base md:text-lg leading-relaxed text-slate-600">
              As a premier B2B content syndication service provider, iTMunch specializes in delivering
              high-quality lead generation solutions for enterprises seeking growth. Our approach begins
              with a deep understanding of your business objectives, followed by careful selection of
              the most suitable platforms.
            </p>
            <p className="text-base md:text-lg leading-relaxed text-slate-600">
              Having successfully supported over <strong className="text-slate-800">90 global brands</strong>,
              we focus on delivering both immediate results and long-term value. Whether you're looking
              to access the best B2B content syndication platforms or need a comprehensive content
              distribution strategy, iTMunch is your trusted partner.
            </p>
          </div>

          <div className="relative">
            <div className="rounded-2xl overflow-hidden shadow-xl shadow-slate-200/50 border border-slate-100">
              <img
                src="https://images.unsplash.com/photo-1460925895917-afdab827c52f?crop=entropy&cs=srgb&fm=jpg&q=85&w=800"
                alt="B2B content syndication analytics dashboard showing campaign performance metrics"
                className="w-full h-auto object-cover aspect-[4/3]"
                loading="lazy"
              />
            </div>
            <div className="absolute -bottom-6 -left-6 w-32 h-32 bg-[#4AC5DB]/10 rounded-2xl -z-10" />
            <div className="absolute -top-6 -right-6 w-24 h-24 bg-[#4AC5DB]/5 rounded-full -z-10" />
          </div>
        </div>
      </div>
    </section>
  );
}
